module.exports = __webpack_public_path__ + "static/media/va.d76a4c0a.svg";